<template>
  <section class="m-5">
    <div class="row">
      <div class="col mt-3">
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-skeleton-table
              :rows="5"
              :columns="3"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table>
          </template>
          <gwzTreeRow
            :fields="fields"
            :items="categories"
            :depth="0"
          ></gwzTreeRow>
        </b-skeleton-wrapper>
      </div>
    </div>
  </section>
</template>

<script>
import gwzTreeRow from "@/components/gwzTreeRow.vue";
import { mapMutations, mapGetters } from "vuex";
import router from "@/router";

export default {
  components: { gwzTreeRow },
  data() {
    return {
      categories: [],
      hierarchyLabel: "",
      fields: [
        { key: "hierarchyLabel", label: "Nom catégorie", colspan: 1 },
        { key: "status", label: "Status", colspan: 1 },
        {
          key: "actions",
          label: "Actions",
          thClass: "text-right pr-4",
          colspan: 1
        }
      ]
    };
  },
  methods: {
    ...mapMutations({ setLoading: "SET_LOADING" })
  },
  computed: {
    ...mapGetters(["isLoading"])
  },
  async created() {
    try {
      await this.setLoading(true);
      const { data } = await this.$gwzApi
        .service("categories")
        .listMiraklTree();
      this.categories = data["hydra:member"];
      await this.setLoading(false);
    } catch (e) {
      this.setLoading(false);
      router.back();
    }
  }
};
</script>
